<template>
  <div
    v-for="(tab, index) in tabs"
    :key="tab.key || keyFn?.(tab)"
    class="flex w-full flex-col"
  >
    <CanBeLink v-slot="{ isActive, isExactActive }" :to="tab.to" or="button">
      <NavVerticalTab
        :="{
          tab,
          index,
          unresponsive,
          isActive: checkActive(tab, exactActive ? isExactActive : isActive)
        }"
      >
        <template #icon>
          <slot name="icon" :="{ tab }"></slot>
        </template>
      </NavVerticalTab>
    </CanBeLink>
  </div>
</template>

<script setup lang="ts" generic="T extends Primitive">
// defines
defineOptions({ inheritAttrs: false })
const { keyFn, activeTab } = defineProps<{
  tabs: NavItem[]
  keyFn?: KeyFn<NavItem>
  activeTab?: T
  unresponsive?: boolean
  exactActive?: boolean
}>()

// methods
const checkActive = (tab: NavItem, navActive?: boolean) => {
  if (!activeTab || (!tab.key && !keyFn)) return !!navActive
  return (tab.key || keyFn?.(tab)) === activeTab
}
</script>
